"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  delay: 0,
  retries: 3
};
/**
 * Bind retry logic to axios instance
 *
 * @param {AxiosInstance} instance - an axios instance you want to bind retry logic
 * @param {Object} config - an object that contain "delay" and "retries"
 * @Example
 * Usage new AxiosRetry(axiosInstance, { delay: 3000, retries: 3 }).execute()
 */

var AxiosRetry = function AxiosRetry(instance, config) {
  var _this = this;

  _classCallCheck(this, AxiosRetry);

  _defineProperty(this, "_reset", function () {
    _this.config = initialState;
    _this.retryCount = 0;
  });

  _defineProperty(this, "_onSuccess", function (res) {
    return res;
  });

  _defineProperty(this, "_onError", function (err) {
    var gqlAuthError = err.response.data && err.response.data.errors && err.response.data.errors.length > 0 && (0, _lodash.filter)(err.response.data.errors, function (error) {
      return error.message && error.message.includes('auth');
    }).length > 0 || false;

    if (!_this.config || err.response.data && _typeof(err.response.data) !== 'object' && err.response.data.includes('AUTH') || gqlAuthError || err.response.status == 429) {
      return Promise.reject(err);
    }

    var shouldRetry = _this.retryCount < _this.config.retries;

    if (shouldRetry) {
      _this.retryCount++;
      err.config.transformRequest = [function (data) {
        return data;
      }];
      return new Promise(function (resolve) {
        return setTimeout(function () {
          resolve(_this.axiosInstance(err.config));
        }, _this.config.delay);
      });
    }

    return Promise.reject(err);
  });

  _defineProperty(this, "execute", function () {
    _this.axiosInstance.interceptors.response.use(_this._onSuccess, _this._onError);
  });

  this.config = config || initialState;
  this.axiosInstance = instance || _axios["default"];
  this.retryCount = 0;
};

exports["default"] = AxiosRetry;